import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["initialState", "content"]
  static values = {
    action: { type: String, default: "show" },
    actionOn: { type: Array, default: [] }
  }

  connect() {
    if (this.hasActionValue && this.hasActionOnValue && this.hasInitialStateTarget) {
      this.toggle({ target: this.initialStateTarget })
    }
  }

  show() {
    this.contentTargets.forEach(el => {
      el.disabled = false
      el.classList.remove("hidden")
    })
  }

  hide() {
    this.contentTargets.forEach(el => {
      el.disabled = true
      el.classList.add("hidden")
    })
  }

  toggle(e) {
    const actionOnMatch = this.actionOnValue.includes(e.target.value)
    if (this.actionValue === "show") {
      actionOnMatch ? this.show() : this.hide()
    } else if (this.actionValue === "hide") {
      actionOnMatch ? this.hide() : this.show()
    } else {
      console.warn(`Unknown action value: ${this.actionValue}. Doing nothing.`)
    }
  }
}
